<ui-segmented-control
	ngDefaultControl
	[id]="field.id || ''"
	[name]="field.id || ''"
	[controlOptions]="getControlOptions()"
	[formControl]="formControl"
	[formlyAttributes]="field"
	[isInvalid]="showError"
></ui-segmented-control>
